import * as userActions from '../user/actions';
import * as lawsDeadlinesLostActions from './actions';
import { CLEAN_PERSISTED_STORAGE } from '~redux_related/GENERAL/actions';

const initialState = {
    list: null,
    isFetching: false,
    isLoaded: false,
    error: '',
};

export const lawsDeadlinesLostReducer = (state = initialState, action) => {
    switch (action.type) {
        case lawsDeadlinesLostActions.SET_LAWS_DEADLINES_LOST_FETCHING:
            return {
                ...state,
                isFetching: action.isFetching,
            };

        case lawsDeadlinesLostActions.SET_LAWS_DEADLINES_LOST_FETCHING_ERROR:
            return {
                list: null,
                isFetching: false,
                isLoaded: true,
                error: action.error,
            };

        case lawsDeadlinesLostActions.SET_LAWS_DEADLINES_LOST:
            return {
                list: action.list,
                isFetching: false,
                isLoaded: true,
                error: '',
            };

        case lawsDeadlinesLostActions.ABORT_DEADLINES_LOST_REQUEST:
            return initialState;

        case lawsDeadlinesLostActions.CLEAN_LAWS_DEADLINES_LOST:
            return initialState;

        case userActions.LOGOUT:
            return initialState;

        case userActions.LOGIN:
            return initialState;

        case CLEAN_PERSISTED_STORAGE:
            return initialState;

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/redux_related/lawsDeadlinesLost/reducer.js